export default __webpack_public_path__ + "static/The Adventure_image 4@2x-9a85c45f2514bc250d45eca9b66803fe.jpg";